import { Card, CardHeader, CardContent } from "@/components/ui/card";
import { formatDateWithYear } from "@/utils/dateFormatters";
import BreadcrumbComponent from "@/components/BreadcrumbComponent";
import { FileCheck, FileText } from "lucide-react";
import CardSkeleton from "@/components/CardSkeleton";
import { useCertificates } from "@/hooks/useCertificates";
import CertificatesStub from "@/components/CertificatesStub";
import { Typography } from "@/components/ui/typography";

const Certificates = () => {
  const { certificates, isLoading } = useCertificates();

  return (
    <div className="flex w-full flex-col p-3">
      <BreadcrumbComponent link={"Справки"} />
      <div className="mb-6 flex flex-col gap-2">
        <div className="flex items-center gap-2">
          <FileText className="h-5 w-5 text-primary" />
          <h2 className="text-xl font-medium text-gray-900">Справки</h2>
        </div>
        <Card className="border-none bg-sky-50 p-4 text-sm text-muted-foreground">
          <p>Для занятий в бассейне нужны медицинские справки:</p>
          <div className="mt-3 space-y-2">
            <p>
              <span className="font-medium text-foreground">Дети старше 1 года:</span> анализ на
              энтеробиоз (обновляется каждые 3 месяца) и заключение педиатра (каждые 6 месяцев)
            </p>
            <p>
              <span className="font-medium text-foreground">Дети до 1 года:</span> заключение
              педиатра
            </p>
          </div>
          <p className="mt-3">
            Мы отслеживаем сроки и напомним, когда придёт время обновить справку. Передайте справки
            администратору бассейна.
          </p>
        </Card>
      </div>
      <div className="m:grid-cols-1 grid gap-4">
        {!isLoading && (!certificates || certificates.length === 0) && <CertificatesStub />}
        {isLoading
          ? [...Array(1)].map((_, index) => <CardSkeleton key={index} />)
          : certificates.map((certificate) => (
              <Card key={certificate.id} className="overflow-hidden">
                <CardHeader className="border-b bg-muted/50 p-4">
                  <div className="flex flex-col gap-2">
                    <div className="group flex items-center gap-3">
                      <div className="rounded-full bg-primary/10 p-2 sm:p-2">
                        <FileCheck className="h-5 w-5 text-primary" />
                      </div>
                      <Typography
                        variant="h3"
                        className="min-w-[40rem] text-lg font-normal text-gray-800 transition-colors group-hover:text-primary md:min-w-[20rem]"
                      >
                        {certificate.name}
                      </Typography>
                    </div>
                  </div>
                </CardHeader>
                <CardContent className="space-y-4 p-4">
                  <div className="flex flex-col gap-3">
                    <div className="flex items-center justify-between text-sm">
                      <Typography variant="muted" className="block">
                        Справка действительна до:{" "}
                      </Typography>
                      <Typography variant="p" className="text-base leading-relaxed">
                        {formatDateWithYear(certificate.end_date)}
                      </Typography>
                    </div>
                  </div>
                </CardContent>
              </Card>
            ))}
      </div>
    </div>
  );
};

export default Certificates;
